import React from 'react'
import { Typography, useMediaQuery, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { ZERO } from 'shared/constants'
import type { ImprovedBalance } from 'shared/graphql/graphql'
import BalanceTable from '../../balance-table'
import InfoModal from '../info-modal'
import type { BalanceModalProps } from './types'
import { useBalanceModal } from './use-balance-modal'

const BalanceModal: React.FC<BalanceModalProps> = (props) => {
  const { task, onClose } = props
  const { breakpoints } = useTheme()
  const { t } = useFavurTranslation()
  const { balances, loading, open, titleLabel, emptyTable } = useBalanceModal(props)
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))

  return (
    <InfoModal isOpen={open} onClose={onClose} headerLabel={titleLabel} isSmallScreen={isSmallScreen}>
      {!task && <Typography variant="body2">{t('absenceRequest.components.employeeSaldo.subtitle')}</Typography>}
      {emptyTable ? null : <BalanceTable isLoading={loading} balance={balances?.[ZERO] as ImprovedBalance} />}
    </InfoModal>
  )
}

export default BalanceModal
